import { getPageUrl } from 'components/storefront/editor/utils/pages';
import { getPageFromEntry } from 'components/storefront/editor/utils/easyblocks';
import { convertSectionGroup } from './section-group';

function getPageSettings(page) {
  const { title, slug, description, $locale } = page;

  const pageSettings = {};

  if (title?.value) {
    pageSettings.title = title.value;
  }

  if (slug?.value) {
    pageSettings.slug = slug.value;
    pageSettings.url = getPageUrl(slug.value);
  }

  if (description?.value) {
    pageSettings.description = description.value;
  }

  if ($locale?.value) {
    pageSettings.$locale = $locale.value;
  }

  return pageSettings;
}

export const convertPage = (entry, contentGroupData) => {
  const sectionGroup = convertSectionGroup(entry, contentGroupData);
  const page = getPageFromEntry(entry);

  sectionGroup.page = getPageSettings(page);

  return sectionGroup;
};
